<template>
  <div class="fullWidthList">
    <div class="d-flex w-100">
      <div class="itemList" v-if="mainHeader && mainHeader.length > 0">
        <div
          v-for="(item, index) in mainHeader"
          :key="index"
          @click="changeMainId(item.id)"
          :class="['item', { selected: item.id == selectedMainId }]"
          :disabled="item.disabled == true"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="w-100 d-flex flex-column">
        <div class="subItemList" v-if="getSubs && getSubs.length > 0">
          <div
            v-for="(item, index) in getSubs"
            :key="index"
            @click="changeSubId(item.id)"
            :class="['item', { selected: item.id == selectedSubId }]"
            v-if="item.name"
          >
            {{ item.name }}
          </div>
        </div>

        <div class="list" v-if="getItems && getItems.length > 0">
          <transition-group name="fade-in-up" v-if="getItems[0].componentName">
            <component
              :is="getItems[0].componentName"
              :key="getItems[0].componentName"
              :vmId="getItems[0].vmId"
              :gatewayId="getItems[0].gatewayId"
              :isEnabled="getItems[0].componentIsEnabled"
            />
          </transition-group>
          <div
            v-else
            v-for="(item, index) in getItems"
            :key="index"
            class="d-flex align-items-center item"
          >
            <div class="name">{{ item.name }}</div>
            <div class="value">{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FullWidthList',
  props: {
    mainHeader: {
      type: Array,
      default() {
        return []
      },
    },
    subHeader: {
      type: Array,
      default() {
        return []
      },
    },
    items: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      selectedMainId: '',
      selectedSubId: '',
    }
  },
  mounted() {
    this.setFirstItems()
  },
  computed: {
    getSubs() {
      return this.subHeader.filter((f) => f.mainId == this.selectedMainId)
    },
    getItems() {
      return this.items.filter(
        (f) => f.mainId == this.selectedMainId && f.subId == this.selectedSubId
      )
    },
  },
  methods: {
    setFirstItems() {
      if (this.mainHeader && this.mainHeader.length > 0) {
        this.selectedMainId = this.mainHeader[0].id

        if (this.getSubs && this.getSubs.length > 0)
          this.selectedSubId = this.getSubs[0].id
      }
    },
    changeMainId(id) {
      this.selectedMainId = id
      if (this.getSubs && this.getSubs.length > 0)
        this.selectedSubId = this.getSubs[0].id
    },
    changeSubId(id) {
      this.selectedSubId = id
    },
  },

  components: {
    // Virtual machine detail
    HardwareCpuRam: () =>
      import('@/components/compute/virtualMachines/tabs/hardware/CpuRam'),
    DiskImages: () =>
      import('@/components/compute/virtualMachines/tabs/hardware/DiskImages'),
    NetworkCards: () =>
      import('@/components/compute/virtualMachines/tabs/hardware/NetworkCards'),
    Ipv4Addresses: () =>
      import('@/components/compute/virtualMachines/tabs/Ipv4Addresses'),
    Performance: () =>
      import('@/components/compute/virtualMachines/tabs/Performance'),
    AvaibleSnapshots: () =>
      import('@/components/compute/virtualMachines/tabs/AvaibleSnapshots'),
    NATRecords: () =>
      import('@/components/compute/virtualMachines/tabs/NATRecords'),
    ProxyRecords: () =>
      import('@/components/compute/virtualMachines/tabs/ProxyRecords'),
    ExecutionList: () =>
      import('@/components/compute/virtualMachines/tabs/ExecutionList'),
    VirtualZones: () =>
      import('@/components/compute/virtualMachines/tabs/VirtualZones'),

    // Cloud node detail
    ComputeMembers: () => import('@/components/cloudNode/tabs/ComputeMembers'),
    ComputePool: () => import('@/components/cloudNode/tabs/ComputePool'),
    StorageMembers: () => import('@/components/cloudNode/tabs/StorageMembers'),
    StorageVolumes: () => import('@/components/cloudNode/tabs/StorageVolumes'),
    StoragePool: () => import('@/components/cloudNode/tabs/StoragePool'),
    NetworkMembers: () => import('@/components/cloudNode/tabs/NetworkMembers'),
    Networks: () => import('@/components/cloudNode/tabs/Networks'),
    NetworkPool: () => import('@/components/cloudNode/tabs/NetworkPool'),
    IPAddresses: () => import('@/components/cloudNode/tabs/IPAddresses'),
    DHCP: () => import('@/components/cloudNode/tabs/DHCP'),
    NAT: () => import('@/components/cloudNode/tabs/NAT'),
    Proxy: () => import('@/components/cloudNode/tabs/Proxy'),
    DNS: () => import('@/components/cloudNode/tabs/DNS'),

    // Streaming cluster detail
    StorageMembersList: () =>
      import('@/components/storagePools/tabs/StorageMembersList'),
    StorageVolumesList: () =>
      import('@/components/storagePools/tabs/StorageVolumesList'),

    // Streaming cluster detail
    EdgeList: () => import('@/components/stream/tabs/EdgeList'),
    OriginList: () => import('@/components/stream/tabs/OriginList'),

    //Gateway
    GatewayHardwareCpuRam: () =>
      import('@/components/networking/gateway/tabs/GatewayHardwareCpuRam'),
    GatewayVirtualZone: () =>
      import('@/components/networking/gateway/tabs/GatewayVirtualZone'),
    GatewayIpManagement: () =>
      import('@/components/networking/gateway/tabs/GatewayIpManagement'),
    GatewayDHCP: () =>
      import('@/components/networking/gateway/tabs/GatewayDHCP'),
    LoadBalancer: () =>
      import('@/components/networking/gateway/tabs/LoadBalancer'),
    NTP: () => import('@/components/networking/gateway/tabs/NTP'),
    VPN: () => import('@/components/networking/gateway/tabs/VPN'),
    GatewayProxyRecords: () =>
      import('@/components/networking/gateway/tabs/GatewayProxyRecords'),
    GatewayNatRecords: () =>
      import('@/components/networking/gateway/tabs/GatewayNatRecords'),

    // Storage
    ComputeManagementList: () =>
      import('@/components/storage/tabs/ComputeManagementList'),
    NetworkManagementList: () =>
      import('@/components/storage/tabs/NetworkManagementList'),
    ServiceManagementList: () =>
      import('@/components/storage/tabs/ServiceManagementList'),
  },
}
</script>

<style lang="scss" scoped>
.fullWidthList {
  width: 100%;

  .itemList {
    border: 1px solid #eeeff3;
    border-radius: 12px;
    cursor: pointer;
    width: 150px;
    margin-top: 54px;
    .item {
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      text-transform: uppercase;
      color: #0a1f44;
      background: #ffffff;
      padding: 20px;
      border: 1px solid #eeeff3;
      &:first-child {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
      }
      &:last-child {
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
      }
      &.selected {
        color: #ffffff;
        background: #0a1f44;
      }
      &[disabled] {
        background: #c5c5c5;
        color: #fff;
      }
    }
  }

  .subItemList {
    border: 1px solid #eeeff3;
    border-radius: 12px;
    cursor: pointer;
    display: flex;
    margin-left: 10px;
    margin-bottom: 10px;
    .item {
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      text-transform: uppercase;
      color: #0a1f44;
      background: #ffffff;
      padding: 10px 25px;
      border: 1px solid #eeeff3;
      &:first-child {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
      }
      &:last-child {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
      }
      &.selected {
        color: #ffffff;
        background: #0a1f44;
      }
    }
  }

  .list {
    box-sizing: border-box;
    margin-left: 10px;
    .item {
      background: #ffffff;
      border: 1px solid #eeeff3;
      border-bottom: 1px solid #e5eaee;
      &:first-child {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
      }
      &:last-child {
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        border-bottom: 1px solid #eeeff3;
      }
      .name {
        font-weight: 600;
        font-size: 14px;
        line-height: 21px;
        color: #b5b5c3;
        padding: 30px 20px;
        text-align: right;
        min-width: 200px;
      }
      .value {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 21px;
        color: #464e5f;
        padding: 30px 20px;
      }
    }
  }
}
</style>
